import moment from "moment";

import { renderAccordionContent } from "@content";

export const getEditInputsByStep = ({ mainStore, detailData, isAdd }) => {
    const typeOffer = detailData.typeOffer || false;
    const viaAgency = detailData?.vendor?.vendorInfo?.workViaAgency || false;

    const steps = {
        step1: [
            {
                blockName: "Оффер",
                inputs: {
                    technicalName: { label: "Техническое название оффера", type: "string", required: true, addClass: "full", placeholder: "Укажите название для внутреннего использования" },
                    ghostOffer: {
                        type: "radiobutton",
                        radioButtonData: [
                            { label: "Реальная", value: false },
                            { label: "Тестовая (оффер - призрак)", value: true },
                        ],
                        defaultValue: false,
                    },
                    vendorId: {
                        label: "Вендор",
                        type: "selectSuggest",
                        apiUrl: "/promo/suggest_list?collection=vendors&project[_id]=1&project[code]=1&project[name]=1&filters[active]=true&sortField=name&sortOrder=asc",
                        dataKey: "suggest.vendors_suggest",
                        refetchOnMountData: true,
                        optionValue: "_id",
                        optionLabel: "name",
                        placeholder: "Выберите вендор",
                        selectedItemKey: "_id",
                        addClass: "full",
                        required: true,
                        showClear: false,
                        eridToRegenerate: "required",
                        fetchVendorItemData: async (e) => {
                            if (e.value) {
                                const resp = await mainStore.getByUrl(`promo/vendors/${e.value}`, false, "detailData.vendor", true, false);
                                if (resp && resp.success && resp.data && resp.data.rateIds && resp.data.rateIds.length === 1) {
                                    mainStore.setMainStore("detailData.rateIds", resp.data.rateIds);
                                }

                                const bucketResp = await mainStore.getByUrl(
                                    `/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1&sortField=name&sortOrder=asc&filters[vendorId]=${e.value}`,
                                    false,
                                    "suggest.buckets_suggest",
                                    true,
                                    true,
                                );

                                if (bucketResp && bucketResp.success) {
                                    mainStore.setMainStore("detailData.bucketCode", null);
                                }
                            }
                        },
                    },
                    parentOfferId: {
                        label: "Открыть родительский оффер",
                        type: "linkTab",
                        addClass: "full",
                    },
                },
            },
        ],
        step2: [
            {
                blockName: "Нейминг оффера",
                inputs: {
                    title: {
                        label: "Название оффера",
                        placeholder: "Введите название",
                        required: true,
                        maxLength: 50,
                        type: "htmlText",
                        addClass: "short",
                        header: () => (
                            <span className="ql-formats">
                                <button className="ql-bold" />
                                <button className="ql-italic" />
                                <button className="ql-underline" />
                                <button className="ql-strike" />
                            </span>
                        ),
                        duplicateToPath: isAdd ? ["name"] : null,
                        translitTo: isAdd ? "code" : null,
                        eridToRegenerate: "optional",
                    },
                    offerOptions: {
                        label: "Опция предложения",
                        type: "switch",
                        switchLabel: "Хит",
                        keyArray: "hit",
                    },

                    link: {
                        type: "link",
                        href: "https://docs.google.com/document/d/1DFDTRFZDi1witRBBsrS0dBP9SaRFDa-mMaFhPxiJqYU/edit?tab=t.0",
                        label: "Рекомендации к названию оффера можно изучить в документе",
                    },
                    code: { label: "Код", type: "string", required: true, placeholder: "Введите код", addClass: "full" },
                },
            },
            {
                blockName: "Превью",
                inputs: {
                    cover: {
                        label: "Desktop",
                        type: "previewItem",
                        pathStorage: "cover",
                        addClass: "full imageupload previewupload",
                        eridToRegenerate: "required",
                    },
                    coverMobile: {
                        label: "Mobile",
                        type: "previewItem",
                        pathStorage: "coverMobile",
                        addClass: "full imageupload previewmobile",
                        eridToRegenerate: "required",
                        // screenshot: true,
                    },
                    label: {
                        type: "label",
                        label: "Если в оффер используется кастомный логотип, обновите его при наведении на текущий логотип. Используйте Desktop (280x87), Mobile (87х87)",
                        style: { color: "#37404C", fontStyle: "italic" },
                    },
                },
            },
        ],
        step3: [
            {
                blockName: "Таргетирование",
                inputs: {
                    switchGeoTarget: {
                        label: "1. Таргетинг по географии оффера (для каких регионов, городов и станций метро будет отображаться оффер)",
                        switchLabel: "Включить",
                        type: "switch",
                        addClass: "full one-line bold",
                        handleChangeSwitch: (key, val) => {
                            if (!val) {
                                mainStore.setMainStore("detailData.geoObject", {});
                            }
                        },
                    },
                    keyGeo: {
                        type: "companiesGeo",
                        triggerShow: "switchGeoTarget",
                        triggerShowValue: true,
                    },
                    switchDeviceTarget: {
                        label: "2. Таргетинг по типу устройства и ОС (для каких устройств и ОС будет отображаться оффер)",
                        switchLabel: "Включить",
                        type: "switch",
                        addClass: "full one-line bold",
                        handleChangeSwitch: (key, val) => {
                            if (!val) {
                                mainStore.setMainStore("detailData.deviceTargetModel", null);
                            }
                        },
                    },
                    accordion: {
                        type: "accordion",
                        triggerShow: "switchDeviceTarget",
                        triggerShowValue: true,
                        content: renderAccordionContent(),
                        header: "Как это работает?",
                        addClass: "full logic-help",
                        icon: "pi pi-info-circle",
                    },
                    deviceTargetModel: {
                        type: "deviceTarget",
                        triggerShow: "switchDeviceTarget",
                        triggerShowValue: true,
                    },
                    switchWorkTime: {
                        label: "3. Таргетинг режима работы оффера",
                        switchLabel: "Включить",
                        type: "switch",
                        addClass: "full one-line bold",
                        handleChangeSwitch: (key, val) => {
                            if (!val) {
                                mainStore.setMainStore("detailData.workLimitationsDays", null);
                                mainStore.setMainStore("detailData.workLimitationsStartTime", null);
                                mainStore.setMainStore("detailData.workLimitationsEndTime", null);
                                return;
                            }
                            mainStore.setMainStore("detailData.workLimitationsDays", [1, 7]);
                        },
                    },

                    workLimitationsDays: {
                        label: "Дни работы оффера",
                        type: "weekDays",
                        defaultValue: [1, 7],
                        triggerShow: "switchWorkTime",
                        triggerShowValue: true,
                        addClass: "full",
                    },
                    workLimitationsStartTime: {
                        label: "Время работы оффера (время указывается по Москве)",
                        type: "dateTime",
                        minDate: false,
                        triggerShow: "switchWorkTime",
                        triggerShowValue: true,
                        timeOnly: true,
                        placeholder: "Выберите время",
                    },
                    workLimitationsEndTime: {
                        label: `\u00A0`,
                        type: "dateTime",
                        minDate: false,
                        triggerShow: "switchWorkTime",
                        triggerShowValue: true,
                        timeOnly: true,
                        placeholder: "Выберите время",
                    },
                },
            },
        ],
        step4: [
            {
                blockName: "Доступ к предложению",
                inputs: {
                    typeOffer: {
                        type: "radiobutton",
                        radioButtonData: [
                            { label: "Вопроса нет", value: false, radioNode: { type: "defaultCard", previewType: "questionOff" } },
                            { label: "Есть вопрос", value: true, radioNode: { type: "defaultCard", previewType: "questionOn" } },
                            { label: "Оффер без модального окна", value: "cpc", radioNode: { type: "defaultCard" } },
                        ],
                        defaultValue: false,
                        handleChangeRadio: (key, val) => {
                            if (val !== true) {
                                mainStore.setMainStore("detailData.surveyId", null);
                            }
                            if (val === "cpc") {
                                mainStore.setMainStore("detailData.inputFields", []); //чтоб не падало в ошибку по гет промо методу
                            }
                            mainStore.setMainStore("detailData.offerTypeCPC", val === "cpc" ? "cpc" : null);
                        },
                    },
                },
            },
            {
                blockName: "Иерархия вопросов",
                inputs: {
                    questions: { type: "questions" },
                },
            },
            {
                blockName: "Данные пользователя",
                inputs: {
                    label: {
                        type: "label",
                        label: "Выберите обязательные поля для модального окна*",
                    },

                    sendApiLeadSwitch: {
                        switchLabel: "Отправлять лиды на ежедневной основе?",
                        type: "switch",
                        addClass: "full",
                        triggerShow: "inputFields",
                        triggerShowValue: false,
                        triggerKeys: {
                            type: "phone",
                        },
                        handleChangeSwitch: (key, val) => {
                            if (!val) {
                                mainStore.setMainStore("detailData.sendApiLeadEmail", null);
                                mainStore.setMainStore("detailData.sendApiLeadDate", null);
                            }
                        },
                    },
                    sendApiLeadEmail: {
                        placeholder: "Введите почту",
                        required: true,
                        type: "email",
                        label: "Введите почту получателя",
                        triggerShow: "sendApiLeadSwitch",
                        triggerShowValue: true,
                    },
                    sendApiLeadDate: {
                        label: "Выберите время отправки",
                        type: "dateTime",
                        placeholder: "Введите время",
                        minDate: false,
                        triggerShow: "sendApiLeadSwitch",
                        triggerShowValue: true,
                        timeOnly: true,
                        required: true,
                    },
                    inputFields: {
                        type: "orderList",
                        onDelItem: (type) => {
                            if (type == "phone") {
                                mainStore.setMainStore("detailData.isVerifiedTelNum", false);
                                mainStore.setMainStore("detailData.sendApiLeadSwitch", false);
                                mainStore.setMainStore("detailData.sendApiLeadEmail", null);
                                mainStore.setMainStore("detailData.sendApiLeadDate", null);
                            }
                        },
                        ...(isAdd
                            ? {
                                  defaultValue: {
                                      active: true,
                                      isVerified: false,
                                      key: "email",
                                      placeholder: "Ваша почта",
                                      require: true,
                                      title: "Почта",
                                      type: "email",
                                  },
                              }
                            : {}),
                    },
                },
            },
        ],
        step5: [
            {
                blockName: "Детальная информация",
                inputs: {
                    description: {
                        type: "htmlText",
                        label: "Пользовательское соглашение",
                        required: detailData.offerTypeCPC === "cpc" ? false : true,
                        addClass: "htmlWPreview",
                        text: "Максимальное количество 325 символов",
                        eridToRegenerate: "optional",
                    },
                    previewMobile: {
                        previewType: "previewMobile",
                        type: "defaultCard",
                        label: "Mobile",
                        addClass: "previewMobile",
                    },
                },
            },
            {
                inputs: {
                    offerDetail: {
                        type: "objectInputs",
                        inputs: {
                            termsOfUse: {
                                type: "htmlText",
                                label: "Условия акции",
                                required: detailData.offerTypeCPC === "cpc" ? false : true,
                                addClass: "htmlWPreview",
                                copyTag: "Вставьте тег с датами в любое место, если нужно указать дату.",
                                copyLabel: "{{start date}} {{end date}}",
                                eridToRegenerate: "optional",
                            },
                        },
                    },
                    previewMobile: {
                        previewType: "previewMobile",
                        type: "defaultCard",
                        label: "Mobile",
                        addClass: "previewMobile",
                    },
                    label: {
                        type: "label",
                        label: "Рекомендуется до 500 символов",
                        addClass: "full",
                        style: { fontSize: "12px", color: "#9FA9B7" },
                    },
                },
            },
            {
                blockName: "Информация о дисклеймере",
                inputs: {
                    disclaimer: {
                        type: "htmlText",
                        label: "Укажите всю правовую информацию для дисклеймера",
                        addClass: "htmlWPreview",
                        maxLength: 345,
                    },
                    previewDisclaimer: {
                        type: "previewDisclaimer",
                        addClass: "previewMobile",
                        label: "Превью",
                    },
                },
            },
        ],
        step6: [
            {
                blockName: "Сортировки",
                inputs: {
                    offerSites: { type: "offerSortConfig" },
                },
            },
            {
                blockName: "Конфигурация оффера",
                inputs: {
                    availableOnTag: {
                        type: "string",
                        triggerShow: "availableOnTag",
                        triggerShowValue: true,
                    },
                    offerType: {
                        type: "radiobutton",
                        radioButtonData: [
                            { value: "bucket", label: "Корзина с промокодами" },
                            { value: "onepromo", label: "Единный промокод" },
                            { value: "partnerlink", label: "Ссылка" },
                            { value: "leads", label: "CPL" },
                        ],
                        label: "Вариант выдачи*",
                        required: true,
                        addClass: "full",
                        defaultValue: "bucket",
                    },
                    onePromo: {
                        triggerShow: "offerType",
                        triggerShowValue: "onepromo",
                        label: "Единый промокод",
                        type: "string",
                        required: true,
                    },
                    bucketCode: {
                        triggerShow: "offerType",
                        triggerShowValue: "bucket",
                        label: "Корзина с промиками",
                        type: "selectSuggest",
                        filterBy: "title,_id",
                        required: true,
                        apiUrl: `/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1&sortField=name&sortOrder=asc`,
                        dataKey: "suggest.buckets_suggest",
                        refetchOnMountData: true,
                        optionValue: "code",
                        optionLabel: "title",
                        placeholder: "Выберите корзину",
                        appendTo: "self",
                        addAdditionalApi: (data) => `&filters[vendorId]=${data?.vendorId}`,
                    },
                    activationLink: {
                        label: "Укажите ссылку на активацию",
                        required: true,
                        type: "string",
                        placeholder: "Укажите ссылку",
                        triggerShow: "offerType",
                        triggerShowValue: ["bucket", "onepromo", "partnerlink"],
                    },
                    copyTag: {
                        label: "При автоподстановке промокода скопируйте и вставьте тег {{PROMOCODE}}",
                        copyLabel: "{{PROMOCODE}}",
                        type: "copyTag",
                        triggerShow: "offerType",
                        triggerShowValue: ["bucket", "onepromo", "partnerlink"],
                    },
                    offerDetail: {
                        type: "objectInputs",
                        inputs: {
                            ordRisPromo: {
                                label: "ORD Ris Promo",
                                type: "string",
                                required: true,
                                placeholder: "Укажите идентификатор",
                            },
                        },
                    },
                    offerOptions: {
                        label: "Опция предложения",
                        type: "switch",
                        switchLabel: "Редирект",
                        keyArray: "redirect",
                    },
                },
            },
            {
                blockName: "Ставки",
                inputs: {
                    vendor: {
                        type: "objectInputs",
                        inputs: {
                            rateIds: {
                                type: "rates",
                                apiUrl: "/promo/suggest_list?collection=rates",
                                multiSelect: true,
                                required: true,
                                label: "Ставки",
                            },
                        },
                    },
                    forecastActivationPercent: {
                        type: "procent",
                        label: "Прогнозный процент активаций",
                        placeholder: "Укажите процент %",
                        required: true,
                        // max: 100,
                        suffix: " %",
                        addClass: "half_screen",
                    },
                },
            },

            {
                blockName: "Коэффициент Виталика 🧢",
                inputs: {
                    brakingCoefficient: {
                        label: "Введите коэффициент",
                        type: "number",
                        defaultValue: 1,
                        required: true,
                        minFractionDigits: 2,
                        maxFractionDigits: 2,
                        min: 0,
                        max: 2,
                        addClass: "small",
                    },

                    copyTag: {
                        label: "Поле заполняется на основании коммерческих договоренностей, значение коэффициента для партнера должно быть согласовано с Виталием Трошко",
                        type: "copyTag",
                    },
                },
            },
            {
                blockName: "Плановые показатели",
                inputs: {
                    alertMetrics: {
                        type: "objectInputs",
                        addClass: "half_screen",
                        inputs: {
                            plannedCtr: {
                                label: "1. Плановый CTR оффера (конверсия из показа в клик)",
                                type: "minMax",
                                addClass: "half_screen",
                                required: true,
                            },
                            plannedCr: {
                                label: `2. Плановый CR (конверсия из клика в "Получить предложение")`,
                                type: "minMax",
                                addClass: "half_screen",
                                required: true,
                            },
                            plannedActivationPercent: {
                                type: "procent",
                                label: "3. Плановый % активаций (не путать с прогнозным!)",
                                placeholder: "Укажите процент %",
                                suffix: " %",
                                addClass: "half_screen",
                                required: true,
                            },
                        },
                    },
                },
            },
            {
                blockName: "Интеграции",
                inputs: {
                    radioApi: {
                        label: "",
                        addClass: "full",
                        type: "switch",
                        switchLabel: "API",
                        defaultValue: false,
                        handleChangeSwitch: (key, val) => {
                            if (!val) {
                                mainStore.setMainStore("detailData.apiSendingIds", []);
                                return;
                            }
                            mainStore.setMainStore("detailData.mailOptions.notSend", true);
                        },
                    },
                    apiSendingIds: {
                        label: "Api Sendings (Отправка по api)",
                        type: "multiSelectSuggest",
                        required: true,
                        apiUrl: "/promo/suggest_list?collection=apisendings&project[_id]=1&project[code]=1&project[title]=1&sortField=name&sortOrder=asc",
                        dataKey: "suggest.apisendings_suggest",
                        refetchOnMountData: true,
                        optionValue: "_id",
                        optionLabel: "title",
                        placeholder: "Выберите отправку",
                        appendTo: "self",
                        triggerShow: "radioApi",
                        triggerShowValue: true,
                    },

                    postback: {
                        type: "objectInputs",
                        inputs: {
                            active: {
                                label: "",
                                addClass: "full",
                                type: "switch",
                                switchLabel: "Postback",
                                defaultValue: false,
                                triggerShow: "vendor.isPostbacksEnabled",
                                triggerShowValue: true,
                            },
                            offerName: {
                                label: "Укажите Offer Name (уникальный идентификатор на стороне вендора*)",
                                required: true,
                                type: "string",
                                placeholder: "Вставьте из ЛК вендора",
                                triggerShow: "postback.active",
                                triggerShowValue: true,
                            },
                            targetStatus: {
                                label: "Укажите статус, который будем получать*",
                                required: true,
                                type: "string",
                                placeholder: "Вставьте из ЛК вендора",
                                triggerShow: "postback.active",
                                triggerShowValue: true,
                            },
                        },
                    },
                },
            },
            {
                blockName: "Расписание работы оффера",
                inputs: {
                    dateEndSwitch: {
                        switchLabel: "С датой окончания",
                        type: "switch",
                        addClass: "full",
                        handleChangeSwitch: (key, val, data) => {
                            if (val) {
                                if (data && data.dateEnd && !moment(data.dateEnd).diff(moment(data.dateStart), "years") > 50) {
                                    mainStore.setMainStore("detailData.dateEnd", data.dateEnd);
                                } else {
                                    mainStore.setMainStore("detailData.dateEnd", "");
                                }
                            } else {
                                mainStore.setMainStore("detailData.dateEnd", "2125-01-01T00:00+00:00");
                            }
                        },
                    },
                    dateStart: { label: "Дата начала оффера", type: "dateTime", required: true },
                    dateEnd: {
                        label: "Дата окончания оффера",
                        type: "dateTime",
                        required: true,
                        triggerShow: "dateEndSwitch",
                        triggerShowValue: true,
                    },
                },
            },

            {
                blockName: "Конфигурация письма",
                inputs: {
                    mailOptions: {
                        label: "Конфиг для писем",
                        type: "objectInputs",
                        required: true,
                        inputs: {
                            notSend: {
                                type: "radiobutton",
                                label: "Отправлять письмо",
                                radioButtonData: [
                                    { label: "Да", value: false },
                                    { label: "Нет", value: true },
                                ],
                                defaultValue: false,
                                addClass: "full",
                            },
                            switchKey: {
                                type: "switch",
                                label: "Уникальная ссылка для письма",
                                switchLabel: "Есть",
                                keyArray: "",
                                handleChangeSwitch: (key, val) => {
                                    if (!val) {
                                        mainStore.setMainStore("detailData.mailOptions.mailActivationLink", "");
                                    }
                                },
                            },
                            mailActivationLink: {
                                label: "Ссылка на активацию в письме",
                                required: true,
                                type: "string",
                                placeholder: "Укажите ссылку",
                                triggerShow: "mailOptions.switchKey",
                                triggerShowValue: true,
                            },
                        },
                    },
                },
            },

            viaAgency
                ? {
                      blockName: "ORD",
                      inputs: {
                          ordTag: {
                              label: "Вставьте ERID из OZON ORD, проверьте соответствие оффер и ERID",
                              type: "copyTag",
                              className: "ord",
                          },
                          ordData: {
                              type: "objectInputs",
                              required: true,
                              inputs: {
                                  title: {
                                      label: "Название креатива для ORD",
                                      required: true,
                                      placeholder: "Укажите название",
                                      type: "string",
                                      addClass: "full",
                                  },
                              },
                          },
                          erid: {
                              label: "Укажите ERID из OZON ORD",
                              required: true,
                              placeholder: "Укажите символы",
                              type: "string",
                          },
                      },
                  }
                : {
                      blockName: "ORD",
                      inputs: {
                          ordData: { type: "ordCompanies" },
                      },
                  },
        ],
    };

    if (!typeOffer) steps.step4[1].hidden = true;

    if (typeOffer === "cpc") {
        steps.step4[1].hidden = true;
        steps.step4[2].hidden = true;
        steps.step5[0].hidden = true;
        steps.step5[1].hidden = true;
    } else {
        steps.step5[2].hidden = true;
    }

    return steps;
};
